import React, { useRef } from 'react';
import { useDidMount } from 'rooks';
import styled from 'styled-components';
import Lottie from 'a/components/Lottie';
import spinner from './assets/bodymovin/loading_workshop.json';

const Container = styled.div`
  width: 1024;
  height: 576;
  background-color: #413b34;
  overflow: hidden;
`;

const LoadingText = styled.p`
  margin: 0;
  position: absolute;
  width: 112;
  height: 26;
  top: 360;
  left: 456;
  opacity: 0.5;
  font-family: Quicksand;
  font-size: 21;
  text-align: center;
  color: #ffffff;
`;

const WorkshopLoading = () => {
  const animationRef = useRef();

  useDidMount(() => {
    animationRef.current.play();
  });

  return (
    <Container>
      <Lottie
        loop
        style={{ top: 0, left: 0, width: 1024, height: 576, position: 'absolute' }}
        source={spinner}
        ref={animationRef}
      />
      <LoadingText>Loading...</LoadingText>
    </Container>
  );
};

export default WorkshopLoading;
